module.exports = __webpack_public_path__ + "media/images/svg/cursor-icon-document-33b884d590e348a057722e4784255781.svg";